var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("img", {
      staticClass: "stea-logo",
      attrs: {
        src: require("../../common/design/images/stealogo.png"),
        alt: _vm.$t("WebServiceToFrontPage")
      }
    }),
    _vm._v(" "),
    _c("span", { staticClass: "site-title" }, [
      _vm._v(_vm._s(_vm.$t("WebService")))
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }